import { useEffect } from 'react';

export default function useStickyScrollLock({ stickyRef, scrollableRef, topOffset = 0 }) {
  // useEffect(() => {
  //   if (!stickyRef?.current || !scrollableRef?.current) return;

  //   const stickyEl = stickyRef.current;
  //   const scrollEl = scrollableRef.current;

  //   let touchStartY = 0;

  //   const onWheel = e => {
  //     const stickyRect = stickyEl.getBoundingClientRect();
  //     const isSticky = stickyRect.top <= topOffset;

  //     if (!isSticky) return; // let window scroll normally

  //     const atTop = scrollEl.scrollTop <= 0;
  //     const atBottom = scrollEl.scrollTop + scrollEl.offsetHeight >= scrollEl.scrollHeight;

  //     const deltaY = e.deltaY;

  //     // Scroll direction: negative = up, positive = down
  //     if ((deltaY < 0 && !atTop) || (deltaY > 0 && !atBottom)) {
  //       e.preventDefault();
  //       scrollEl.scrollBy({ top: deltaY, left: 0, behavior: 'auto' });
  //     }
  //     // else allow window scroll
  //   };

  //   const onTouchStart = e => {
  //     if (e.touches.length === 1) touchStartY = e.touches[0].clientY;
  //   };

  //   const onTouchMove = e => {
  //     if (e.touches.length !== 1) return;
  //     const touchY = e.touches[0].clientY;
  //     const deltaY = touchStartY - touchY;

  //     const stickyRect = stickyEl.getBoundingClientRect();
  //     const isSticky = stickyRect.top <= topOffset;

  //     if (!isSticky) return;

  //     const atTop = scrollEl.scrollTop <= 0;
  //     const atBottom = scrollEl.scrollTop + scrollEl.offsetHeight >= scrollEl.scrollHeight;

  //     if ((deltaY < 0 && !atTop) || (deltaY > 0 && !atBottom)) {
  //       e.preventDefault();
  //       scrollEl.scrollBy({ top: deltaY, left: 0, behavior: 'auto' });
  //       touchStartY = touchY;
  //     } else {
  //       touchStartY = touchY; // update even when window scroll happens
  //     }
  //   };

  //   window.addEventListener('wheel', onWheel, { passive: false });
  //   window.addEventListener('touchstart', onTouchStart, { passive: true });
  //   window.addEventListener('touchmove', onTouchMove, { passive: false });

  //   return () => {
  //     window.removeEventListener('wheel', onWheel);
  //     window.removeEventListener('touchstart', onTouchStart);
  //     window.removeEventListener('touchmove', onTouchMove);
  //   };
  // }, [stickyRef, scrollableRef, topOffset]);

  useEffect(() => {
    const handleWheel = (e) => {
      const sticky = stickyRef.current;
      const scrollable = scrollableRef.current;
  
      if (!sticky || !scrollable) return;
  
      const rect = sticky.getBoundingClientRect();
      const isStuck = rect.top <= topOffset;
  
      if (!isStuck) return;
  
      const canScrollDown =
        scrollable.scrollTop + scrollable.clientHeight < scrollable.scrollHeight;
  
      const canScrollUp = scrollable.scrollTop > 0;
  
      if (
        (e.deltaY > 0 && canScrollDown) ||
        (e.deltaY < 0 && canScrollUp)
      ) {
        e.preventDefault();
        scrollable.scrollTop += e.deltaY;
      }
      // else → allow default (body scroll)
    };
  
    window.addEventListener("wheel", handleWheel, { passive: false });
  
    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, [stickyRef, scrollableRef, topOffset]);
}
